import request from "./request";
export const http = {
  // Q-补拍查询(采货侠)
  listarchiveRemakeByOrderNoCHX(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/listRemakeByOrderNoCHX",
      params,
    });
  },
  // Q-外部商家报价列表
  getarchiveListQuoteByOrderNoOut(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/listQuoteByOrderNoOut",
      params,
    });
  },
  //重复询价详情
  orderarchiveinfoRepeat(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/infoRepeat",
      params,
    });
  },
  // 同串号按本单拉齐详情
  imeiarchiveSameInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/imei-same-info",
      params,
    });
  },
  // 收货地址
  getarchiveReceiveAddress(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getReceiveAddress",
      params,
    });
  },
  //报价推送记录
  getarchivePushQuoteRecord(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/archive/getPushQuoteRecord",
      data: params,
    });
  },
  //Q-平台加价详情
  getarchiveMakeUpInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getMakeUpInfo",
      params: params,
    });
  },
  //补贴加价前置信息
  getarchiveMakeUpExpInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getMakeUpExpInfo",
      params: params,
    });
  },
  //导出excel
  archiveOrderExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/archive/excel",
      data: params,
      responseType: "blob",
    });
  },
  //订单列表
  archiveorderList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/archive/list",
      data: params,
    });
  },
  //导出excel
  getQuickQuoteOrderExcel(params) {
    return request({
      method: "POST",
      url: "/merchant/pc/quick/quote/order/getQuickQuoteOrderExcel",
      data: params,
      responseType: "blob",
    });
  },
  //-归档年份
  getArchiveYear(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/year",
      params: params,
    });
  },

  //订单详情
  archiveOrderInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/info",
      params: params,
    });
  },
  //报价修改信息列表
  getArchiveUpdatedQuoteLog(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getUpdatedQuoteLog",
      params,
    });
  },
  //验机报告
  getArchiveInspectionReport(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getInspectionReport",
      params,
    });
  },
  // Q-撤销收货详情
  findCancelReceiptInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/findCancelReceiptInfo", // 没有
      params,
    });
  },
  // 订单列表-所有报价商
  archiveListQuoteByOrderNo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/listQuoteByOrderNo",
      params,
    });
  },
  // 订单动态
  archiveOrderFlow(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/orderFlow",
      params,
    });
  },
  // 加价详情
  archiveAddPriceInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/addPriceInfo",
      params,
    });
  },
  // Q-审单-快捷报价详情
  getArchiveExamineOrQuickInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getExamineOrQuickInfo",
      params,
    });
  },
  // 报低价提醒详情
  archiveLowPriceAlertInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/low-price-alert-info",
      params,
    });
  },
  // 配置列表（低价）
  limitationLowList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/limitation/listLow", //没改
      data: params,
    });
  },
  // 保存配置（低价）
  savelimitationLowconfig(params) {
    return request({
      method: "POST",
      url: "/platform/pc/limitation/saveLow", //没改
      data: params,
    });
  },
  // 订单列表成交价明细
  getArchiveQuoteCompute(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/archive/getQuoteCompute",
      params,
    });
  },
  // 报价限制配置列表
  limitationList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/limitation/list", //没改
      data: params,
    });
  },
  //获取报高价取值字段配置
  getheightlimitationInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/limitation/get-config", //没改
      params,
    });
  },
  // 报价限制配置保存
  savelimitationconfig(params) {
    return request({
      method: "POST",
      url: "/platform/pc/limitation/save", //没改
      data: params,
    });
  },
};
